import styled from "styled-components";

export const Container = styled.div`
    width: 90%;
    margin: 0 auto;
`;

export const Link = styled.a`
    display: inline-block;
    padding: 0.5rem 1rem;
    border-radius: 5rem;
    text-align: center;
    position: relative;
    overflow: hidden;

    &::before {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background: var(--main);
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        transform: translateX(-120%);
        transform-origin: left;
        transition: transform 600ms cubic-bezier(0.165, 0.84, 0.44, 1);
    }

    &:hover::before {
        transform: translateX(0%);
        box-shadow: 0 0 1rem var(--main);
    }
`;

export const CTA = styled(Link)`
    background: var(--main-2);
    overflow: unset;
    text-transform: uppercase;
    margin-top: 2rem;
    font-size: 1.3rem;
    padding: 0.5em 2em;
    &:hover {
        background: var(--main);
        transform: scale(1.1);
        box-shadow: 0 0 1rem var(--main);
    }

    &::before {
        display: none;
    }
`;

export const Title = styled.h2`
    text-transform:uppercase;
    text-align:center;
    letter-spacing:3px;
    font-size:2rem;
    font-family:'Lato',sans-serif;

    &::after{
        content:'';
        display:block;
        width:3rem;
        height:0.3rem;
        background:var(--main);
        margin:1rem auto;
    }
`;

export const Section = styled.section`
    padding:3rem 0;
`
